export const SET_LISTES_FACTURES = 'SET_LISTES_FACTURES';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_TOTAL_FACTURES = 'SET_TOTAL_FACTURES';
